import { useGetConfigurationByPlantQuery } from "Services/Admin/ConfigurationApiSlice";

const PLANT = process.env.REACT_APP_PLANT || "";

export const useEcomConfig = () => {
  const { data: ecomConfig, isLoading, error } = useGetConfigurationByPlantQuery(PLANT);

  const numberOfDecimal =
    ecomConfig?.numberOfDecimal != null
      ? parseInt(ecomConfig.numberOfDecimal, 10)
      : 0;

  const allowLTAVAILINVQTY = ecomConfig?.allow_LTAVAILINVQTY || 0;
  const showAuthor = ecomConfig?.isAuthor === 1;
  const showLanguage = ecomConfig?.isLanguage === 1;
  const showAcademic = ecomConfig?.isAcademic === 1;
  const showMerchandise = ecomConfig?.isMerchandise === 1;
  const showOffers = ecomConfig?.isOffers === 1;
  const showEvents = ecomConfig?.isEvents === 1;
  const showGlossary = ecomConfig?.isGlossary === 1;
  const showHistory = ecomConfig?.isHistory === 1;
  const showPromotion = ecomConfig?.isPromotionEnabled === 1;
  const showSellBooks = ecomConfig?.isSellBooksEnabled === 1; 
  const isLoyaltyPointsEnabled = ecomConfig?.isLoyaltyPointsEnabled ?? false;
  const isWalletEnabled = ecomConfig?.isWalletEnabled ?? false;
  const rawMaxCartQty = ecomConfig?.maxCartQtyPerProduct ?? 0;
  const maxCartQty = rawMaxCartQty > 0 ? rawMaxCartQty : Infinity;
  const minInvQtyPerProduct = ecomConfig?.minInvQtyPerProduct ?? 0;

  return {
    ecomConfig,
    isLoading,
    error,
    numberOfDecimal,
    allowLTAVAILINVQTY,
    showAuthor,
    showLanguage,
    showAcademic,
    showMerchandise,
    showOffers,
    showEvents,
    showGlossary,
    showHistory,
    showPromotion,
    showSellBooks,
    isLoyaltyPointsEnabled,
    isWalletEnabled,
    maxCartQty,
    minInvQtyPerProduct,
  };
};
